import { WretchError } from 'wretch/resolver'
import { ZodError } from 'zod'

import type { DetailedErrorParams } from './dynamicErrorSchema'

export class ApiRequestErrorNetwork extends Error {
  public data: WretchError

  constructor(data: WretchError) {
    super('Network error')
    this.data = data
  }
}

export class ApiRequestErrorNetworkBackend extends ApiRequestErrorNetwork {
  public dynamicError: DetailedErrorParams

  constructor(data: WretchError, dynamicError: DetailedErrorParams) {
    super(data)
    this.dynamicError = dynamicError
  }
}

export class ApiRequestErrorValidation extends Error {
  public data: ZodError

  constructor(data: ZodError) {
    super('Validation error')

    this.data = data
  }
}

export class ApiRequestErrorUnknown extends Error {
  public data: unknown

  constructor(data: unknown) {
    super('Unknown error')

    this.data = data
  }
}
